import React from 'react';
import styled from 'styled-components';
import {
  color as colors,
  theme
} from '@workboard/wobo-ui';
import i18next from 'i18next';
import ErrorOutline from '@material-ui/icons/ErrorOutline';

const P = styled('p')``;

const EmptyTemplate = ({ className }) => (
  <div className={className}>
    <ErrorOutline className="error-icon" />
    <P>
      {i18next.t('No data found.')} {i18next.t('If you believe this is an error, please contact your account team.')}
    </P>
  </div>
);

export default styled(EmptyTemplate)`
  align-items: top;
  display: flex;

  .error-icon {
    height: 18px;
    width: 18px;

    * {
      fill: red;
    }
  }

  ${P} {
    margin: 0 0 0 8px;
    color: ${colors("--black-opacity-60")};
    font-family: ${theme("--font-italic")};
    font-style: italic;
  }
`;
